import { formData } from "./formData"
import { tool } from "./tool"
import { socketFun, numberFun } from "./socket"
export default{
  formData,
  tool,
  socketFun,
  numberFun
}